import { Skeleton } from '@mui/material';
import React from 'react';

import SmallForm from './small-form';

import Arranger from '~c/components/base/arranger';
import Spacer, { spc } from '~c/components/base/spacer';

interface Props {
  className?: string;
}

/**
 * SignInSkeleton is a loading skeleton component that shows while
 * Google Client ID and reCAPTCHA keys are being loaded.
 *
 * It mimics the structure of the actual sign-in form to provide
 * visual feedback during the loading state.
 */
const SignInSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <SmallForm
      className={className}
      title={
        <Arranger direction="column" alignItems="center">
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton
            variant="text"
            width={120}
            height={40}
            sx={{ mt: spc.xxxs }}
          />
        </Arranger>
      }
    >
      <Arranger direction="column">
        {/* Email field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Spacer mb={spc.between_vertical_s} />

        {/* Password field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />

        <Spacer mb={spc.xl} />

        {/* Submit button skeleton */}
        <Skeleton variant="rounded" width="100%" height={48} />

        <Spacer mb={spc.l} />

        {/* Divider skeleton */}
        <Skeleton variant="rectangular" width="100%" height={1} />

        <Spacer mb={spc.l} />

        {/* Google OAuth button skeleton */}
        <Skeleton variant="rounded" width="100%" height={48} />

        <Spacer mb={spc.l} />

        {/* Links skeleton */}
        <Arranger justify="space-between">
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={160} height={20} />
        </Arranger>
      </Arranger>
    </SmallForm>
  );
};

export default SignInSkeleton;
